import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import avatar from 'flarum/common/helpers/avatar';

/**
 * Username suggestions for an @mention being typed.
 *
 * Laid out as a single horizontal strip that takes the composer tool bar's
 * place while it is open. On a phone the keyboard already covers half the
 * screen; a dropdown floating over the canvas hid the very text being written,
 * and a vertical list left nowhere for the toolbar to go.
 *
 * Deliberately stateless: the search state lives in the host component (see
 * mentionSearch.js), because Mithril owns component instances and a reference
 * kept by the parent is not the object that ends up on screen.
 *
 * Props:
 *   results  – users to offer
 *   loading  – whether a search is in flight
 *   index    – highlighted entry
 *   onchoose – callback(user)
 */
export default class MentionAutocomplete extends Component {
  view() {
    const { results, loading, index } = this.attrs;

    return (
      <div className="StoryMentions">
        {loading && results.length === 0 ? (
          // Skeletons rather than a spinner: they occupy exactly the space the
          // real suggestions will, so the strip doesn't resize when they land.
          [0, 1, 2].map((i) => (
            <span className="StoryMentions-item StoryMentions-item--skeleton" key={'skeleton-' + i}>
              <span className="StoryMentions-avatar StoryMentions-skeletonAvatar" />
              <span className="StoryMentions-skeletonName" style={{ width: 52 + i * 14 + 'px' }} />
            </span>
          ))
        ) : results.length === 0 ? (
          <span className="StoryMentions-empty">
            {app.translator.trans('happydigital-stories.forum.mention_no_results')}
          </span>
        ) : (
          results.map((user, i) => (
            <button
              type="button"
              className={'StoryMentions-item' + (i === index ? ' is-active' : '')}
              key={user.id()}
              // mousedown, not click: the textarea would lose focus first and
              // the caret position we need would be gone.
              onmousedown={(e) => {
                e.preventDefault();
                this.attrs.onchoose(user);
              }}
            >
              {avatar(user, { className: 'StoryMentions-avatar' })}
              <span className="StoryMentions-name">{user.username()}</span>
            </button>
          ))
        )}
      </div>
    );
  }
}
